import api from '@/plugins/api'
import { billUrls } from '@/configs/endpoints'
import { SUCCESS_CODES } from '@/configs/constants'

export default {
  state: () => ({
    bill: null
  }),
  mutations: {
    SET_DATA_BILL(state, data) {
      Object.assign(state, data)
    }
  },
  actions: {
    async getBill({ commit }) {
      try {
        const response = await api.get(billUrls.index)
        if (SUCCESS_CODES.includes(response?.code)) {
          commit('SET_DATA_BILL', { bill: response.data })
        }
        return response
      } catch (error) {
        console.error('Failed to get bill:', error)
      }
    },
    async takeCredit({ dispatch }) {
      try {
        const response = await api.post(billUrls.credit)
        if (SUCCESS_CODES.includes(response?.code)) await dispatch('getBill')
        return response
      } catch (error) {
        console.error('Failed to take credit:', error)
      }
    },
    async getExpireBillData(_, query = {}) {
      try {
        const formattedQuery = new URLSearchParams(query).toString()
        return await api.get(billUrls.expire + `?${formattedQuery}`)
      } catch (error) {
        console.error('Failed to get expire bill data:', error)
      }
    },
    async getBillPayments(_, { page = 1 } = {}) {
      try {
        return api.get(`${billUrls.payments}?page=${page}`)
      } catch (error) {
        console.error('Failed to get bill payments:', error)
      }
    },
    async getBillFees() {
      try {
        return api.get(billUrls.fees)
      } catch (error) {
        console.error('Failed to get bill fees:', error)
      }
    }
  }
}
